import { render, staticRenderFns } from "./SaveBuilderTemplate.vue?vue&type=template&id=e6fe4ffe"
import script from "./SaveBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./SaveBuilderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports